<app-norm-template [norm]="norm" [configuration]="configuration" [zone]="zone"
(cancel)="cancel()"
                   (added)="cancel()"
></app-norm-template>
<app-overflow-spinner [showSpinner]="pending"></app-overflow-spinner>
